import React, { ReactElement } from 'react'

import { RecipeNumberedSteps } from '@mindfulchefuk/features/Recipes/components/RecipeSteps/RecipeNumberedSteps'
import { APIRecipe } from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeBeforeYouStart } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/RecipeBeforeYouStart'
import { hasAllRecipeStepTitles } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/hasAllRecipeStepTitles'
import { SortedRecipeInstructionsWithTitles } from '@mindfulchefuk/features/Recipes/components/RecipeModal/SortedRecipeInstructionsWithTitles'

type TRecipePageInstructions = {
  recipe: APIRecipe
}

export const RecipePageInstructions = ({
  recipe,
}: TRecipePageInstructions): ReactElement => {
  const hasBeforeYouStart = recipe.before_you_start

  const hasAllRecipeTitles = hasAllRecipeStepTitles(recipe.steps)

  return (
    <>
      {hasBeforeYouStart && (
        <RecipeBeforeYouStart beforeYouStart={recipe.before_you_start} />
      )}
      {hasAllRecipeTitles ? (
        <SortedRecipeInstructionsWithTitles instructions={recipe.steps} />
      ) : (
        <RecipeNumberedSteps steps={recipe.steps} />
      )}
    </>
  )
}
